import React, { FunctionComponent, useEffect, useState } from 'react';
import Sms from "@murphy-frontend/web-core/assets/icons/sms.svg";
import Notification from "@murphy-frontend/web-core/assets/icons/noti.svg";
import Email from "@murphy-frontend/web-core/assets/icons/email.svg";
import { CustomCheckbox } from '../../../common/components/MurphyCheckbox';
import { MBSRecipient } from './models';
import SearchBar from '@murphy-frontend/web-core/components/SearchBar';

interface MBSChooseRecipientsProps {
  recipients: MBSRecipient[],
  contactGroups: MBSRecipient[],
  translations: Record<string, string>,
  removeRecipient?: (recipient: MBSRecipient) => void,
  clickRecipient?: (recipient: MBSRecipient) => void,
  addRecipient?: (recipient: MBSRecipient) => void
}

const MBSChooseRecipients: FunctionComponent<MBSChooseRecipientsProps> = ({
  recipients,
  translations,
  clickRecipient,
  addRecipient
}) => {
  const [searchText, setSearchText] = useState("");
  const [recipientslist, setRecipientsList] = useState(recipients);

  useEffect(() => {
    if (searchText) {
      setRecipientsList(
        recipients.filter(p =>
          p.name.toUpperCase().startsWith(searchText.toUpperCase()) || p.email?.toUpperCase().startsWith(searchText.toUpperCase())
        )
      );
    } else {
      setRecipientsList(recipients);
    }
  }, [recipients, searchText]);

  return (
    <div className='cr-container'>
      <label className='cr-section-label'>
        {translations.chooserecipients || "Choose recipients"}
      </label>

      <div className='cr-searchbar-container'>
        <SearchBar
          val={searchText}
          showSearchIcon
          handleChange={(event) => setSearchText(event.target.value)}
          placeholder={translations["placeholder-lang-search-action"]}
        />
      </div>

      <label className='cr-subsection-label'>
        {translations.contactgrps || "Contact groups"}
      </label>
      <div className='cr-group-container'>
        {recipientslist.map(item =>
          item.isGroup && (
            <div key={item.name} className='cr-button-container'>
              <CustomCheckbox
                onChange={() => addRecipient?.(item)}
                checked={item?.isAdded}
                checkedColor="#00A098"
                unCheckedColor="#7F7F7F"
              />
              <label
                onClick={() => clickRecipient?.(item)}
                style={{ marginLeft: 10, overflow: 'hidden', width: '20rem', textOverflow: "ellipsis", cursor: 'pointer' }}
              >
                {item.name} ({item.groupMembers?.length || 0})
              </label>
            </div>
          )
        )}
      </div>

      <label className='cr-subsection-label'>
        {translations.alertRecipients || "Recipients"}
      </label>
      <div className='cr-recipient-container'>
        {recipientslist.map(item =>
          !item.isGroup && (
            <div key={item.name} className='cr-contacts-container'>
              <div className='cr-contact-left'>
                <CustomCheckbox
                  onChange={() => addRecipient?.(item)}
                  checked={item?.isAdded}
                  checkedColor="#00A098"
                  unCheckedColor="#7F7F7F"
                />
                <label className='cr-label-truncate'>{item.name}</label>
              </div>
              <div className='cr-contact-right'>
              {item.mobileChecked && item.mobile && <Sms />}
              {item.emailChecked && item.email && <Email />}
              {item.notificationChecked && item.deviceToken && <Notification />}
            </div>
            </div>
          )
        )}
      </div>
    </div>
  );
};

export default MBSChooseRecipients;
